// extracted by mini-css-extract-plugin
export default {"form":"EditBlog_form__OY12G","blogContainer":"EditBlog_blogContainer__EBLDn"};